import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';


const DeleteModal = ({handleClose, showDeleteModal, selectedRowId}) => {
  
  const handleSubmit = async () => {
  
      // Send data to the backend
      const response = await axios.delete(`https://hms.backend.hiragroupcloud.com/api/delete-sport-guard/${selectedRowId}`); 

  
      // Close modal after submission
      handleClose();
  };
  
  return (
    <Modal show={showDeleteModal} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Edit Next Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Do you really want to delete?</p>
        <div className="mb-3">
          <input
            type="hidden"
            id="modalDescription"
            className="form-control"
            name="name"
            value={selectedRowId}
          />
        </div>

      </Modal.Body>
      <Modal.Footer>
  <button 
    style={{
      backgroundColor: 'red',
      border: 'none',
      color: 'white',
      cursor: 'pointer',
      padding: '10px 15px',
      fontSize: '16px',
      marginLeft: '10px',
    }} 
    onClick={handleSubmit}
  >
    Delete
  </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
